import {
  AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, EventEmitter,
  HostListener, Input, Output, ViewChild,
} from "@angular/core";
import { BusyState, ScheduleForm } from "../models/schedule.model";

/**
 * Confirmation for cancelling a whole schedule.
 * The dismiss button is deliberately labelled "Keep schedule" so it can
 * never be confused with the "Cancel schedule" action.
 */
@Component({
  selector: "app-cancel-schedule",
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ["../edit-schedule/edit-schedule.component.css"],
  templateUrl: "./cancel-schedule.component.html",
})
export class CancelScheduleComponent implements AfterViewInit {
  @Input() form!: ScheduleForm;
  @Input() busy: BusyState = "idle";

  @Output() confirm = new EventEmitter<string>();
  @Output() dismiss = new EventEmitter<void>();

  @ViewChild("keepBtn") keepBtn!: ElementRef<HTMLButtonElement>;

  reason = "";

  ngAfterViewInit(): void {
    // The safe choice gets the initial focus
    setTimeout(() => this.keepBtn?.nativeElement.focus());
  }

  get saving(): boolean {
    return this.busy == "saving";
  }

  get canConfirm(): boolean {
    return !this.saving && this.reason.trim().length >= 3;
  }

  get confirmLabel(): string {
    return this.saving ? "Cancelling..." : "Cancel schedule";
  }

  onReasonInput(event: Event): void {
    this.reason = (event.target as HTMLTextAreaElement).value;
  }

  submit(): void {
    if (!this.canConfirm) {
      return;
    }
    const reason = this.reason.trim();
    console.log("[cancel-schedule] emitting confirm", reason);
    this.confirm.emit(reason);
  }

  close(): void {
    if (!this.saving) {
      this.dismiss.emit();
    }
  }

  @HostListener("document:keydown.escape")
  onEscape(): void {
    this.close();
  }

  onBackdrop(event: MouseEvent): void {
    if (event.target === event.currentTarget) {
      this.close();
    }
  }
}